import { render } from "./ContactUsAction.vue?vue&type=template&id=0a855c8c&scoped=true"
import script from "./ContactUsAction.vue?vue&type=script&lang=js"
export * from "./ContactUsAction.vue?vue&type=script&lang=js"

import "./ContactUsAction.vue?vue&type=style&index=0&id=0a855c8c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a855c8c"]])

export default __exports__